import React from 'react'
import PropTypes from 'prop-types'

const HOC = (WrappedComponent) => {
  class NavTabs extends React.Component {
    state = { active: 0 }

    // sync the value from props to state
    static getDerivedStateFromProps(props) {
      if (props.active !== undefined) {
        if (props.withRouter) {
          return {
            active: props.tabs.findIndex((t) => t.path === props.active),
          }
        }
        return {
          active: props.active,
        }
      }
      return null
    }

    handleRedirect = (event, path) => {
      let url = window.location.origin
      const tabPath = event.currentTarget.getAttribute('data-url')
      url = window.location.hash ? `${url}/#` : url
      url = `${url}${path}/${tabPath}`
      window.location = url
    }

    handleChange = (event, active) => {
      const tabPath = event.currentTarget.getAttribute('data-url')
      if (this.props.withRouter && this.props.path) {
        this.handleRedirect(event, this.props.path)
      } else if (this.props.handleActive) {
        this.props.handleActive(active, tabPath)
      }
      this.props.onSelected(tabPath)
      this.setState({ active })
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          active={this.state.active}
          handleChange={this.handleChange}
        />
      )
    }
  }

  NavTabs.propTypes = {
    path: PropTypes.string,
    withRouter: PropTypes.bool,
    handleActive: PropTypes.func,
    tabs: PropTypes.arrayOf(Object).isRequired,
    onSelected: PropTypes.func,
  }

  NavTabs.defaultProps = {
    withRouter: true,
    onSelected: () => {},
  }

  return NavTabs
}

export default HOC
